import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from "@angular/core";
import {
  provideRouter,
  withComponentInputBinding,
  withHashLocation,
} from "@angular/router";
import { routes } from "./app.routes";
import { DatePipe } from "@angular/common";
import { SharedService } from "./services/sharedService";
import { provideProtractorTestingSupport } from "@angular/platform-browser";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { regionInterceptor } from "./shared/interceptors/region.interceptor";
import { AppLoadService } from "./app-load/app-load.service";
import { provideFirebaseApp, initializeApp } from "@angular/fire/app";
import { provideAuth, getAuth } from "@angular/fire/auth";
import { environment } from "../environments/environment";
import { provideDatabase, getDatabase } from "@angular/fire/database";
import { provideNativeDateAdapter } from "@angular/material/core";
import { provideAnimations } from '@angular/platform-browser/animations';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true, runCoalescing: true }),
    provideRouter(routes, withHashLocation(), withComponentInputBinding()),
    importProvidersFrom(DatePipe),
    SharedService,
    provideProtractorTestingSupport(),
    provideHttpClient(withInterceptors([regionInterceptor])),
    provideAppInitializer(() => {
      const appLoadService = inject(AppLoadService);
      return appLoadService.checkTokenExpiry();
    }),
    AppLoadService,
    provideFirebaseApp(() => initializeApp(environment.firebase)),

    provideAuth(() => getAuth()),

    provideDatabase(() => getDatabase()),
    provideNativeDateAdapter(),
    provideAnimations()
  ],
};
